import React from 'react'
import {
    Box,
    Flex,
    Icon,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

const ProductRegistrationCard = ({
    icon,
    variant,
    title,
    description,
    additionalDescription,
    datatestid,
    bg,
}) => {
    const styles = useMultiStyleConfig('ProductRegistration', {variant})
    return (
        <Flex {...styles.singleCardContainer} bg={bg} data-testid={datatestid}>
            <Box {...styles.cardInnerContainer}>
                <Icon as={icon} {...styles.cardIcon} />
                <Box {...styles.cardDescriptionContainer}>
                    <Text {...styles.cardDescription}>{title}</Text>
                    <Text textStyle={'body-xsmall'} fontWeight={'medium'}>
                        {description}
                    </Text>
                    <Text textStyle={'body-xsmall'} fontWeight={'medium'}>
                        {additionalDescription}
                    </Text>
                </Box>
            </Box>
        </Flex>
    )
}

ProductRegistrationCard.propTypes = {
    icon: PropTypes.elementType,
    title: PropTypes.node,
    description: PropTypes.node,
    additionalDescription: PropTypes.node,
    variant: PropTypes.string,
    datatestid: PropTypes.string,
    bg: PropTypes.string,
}

export default ProductRegistrationCard
